export default "__VITE_ASSET__B0uCht8n__"